/**
 * Runtime configuration for the API layer.
 *
 * The site is built to be dropped into a Next.js App Router project on Vercel,
 * where the API routes live in the SAME project. Every path below is therefore
 * relative and same origin: no CORS, no base URL, and the session cookie is
 * sent automatically.
 *
 * While the routes do not exist yet, LIVE_API stays false and the client falls
 * back to the in browser demonstration behaviour so the site remains usable.
 * Once the routes are deployed, set NEXT_PUBLIC_LIVE_API to "true" in Vercel.
 */

function readEnv(key: string): string | undefined {
  try {
    const metaEnv = (import.meta as unknown as { env?: Record<string, string> }).env
    if (metaEnv && metaEnv[key]) return metaEnv[key]
  } catch {
    /* import.meta is unavailable in some bundlers */
  }
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key]
  }
  return undefined
}

export const LIVE_API = readEnv('NEXT_PUBLIC_LIVE_API') === 'true'

/**
 * Transactional email. The addresses are held here so the copy shown to the
 * visitor and the server route that actually sends stay in step. Sending happens
 * server side through Resend, never from the browser.
 */
export const MAIL = {
  /** Sender for the assessment result, download links and portal notifications. */
  from: 'no-reply@cavalladata.com',
  /** Blind copied on every result so the team sees each completed assessment. */
  bcc: 'jonathanmclarke08@gmail.com',
} as const

/** Every server route the front end calls. Same origin, App Router handlers. */
export const ENDPOINTS = {
  events: '/api/events',
  leads: '/api/leads',
  assessmentResult: '/api/assessment/result',
  readerStatus: '/api/reader/status',
  download: '/api/files/download',
  concierge: '/api/concierge',
  session: '/api/auth/session',
  login: '/api/auth/login',
  mfa: '/api/auth/mfa',
  magicLink: '/api/auth/magic-link',
  logout: '/api/auth/logout',
} as const
